import { render, staticRenderFns } from "./IncrementNumber.vue?vue&type=template&id=029b632f&scoped=true&"
import script from "./IncrementNumber.vue?vue&type=script&lang=js&"
export * from "./IncrementNumber.vue?vue&type=script&lang=js&"
import style0 from "./IncrementNumber.vue?vue&type=style&index=0&id=029b632f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029b632f",
  null
  
)

export default component.exports